import { sis_giaovien_view } from "../models/response/giao-vien/sis_giaovien";
import { apiClient } from "./apiClient";

export const GIAO_VIEN_API_END_POINT = "giao-vien";

export const giaoVienApi = {
    // Get all giao vien
    selectAll: () => 
        apiClient.get(`${GIAO_VIEN_API_END_POINT}`),
    
    // Get giao vien by truong
    selectByTruong: (dm_truong_id: number) => 
        apiClient.get(`truong/${dm_truong_id}/${GIAO_VIEN_API_END_POINT}`),
    
    // Get giao vien by co so
    selectByCoso: (dm_coso_id: number) => 
        apiClient.get(`co-so/${dm_coso_id}/${GIAO_VIEN_API_END_POINT}`),
    
    // Get giao vien by id
    detail: (id: number) => 
        apiClient.get(`${GIAO_VIEN_API_END_POINT}/${id}`),
    
    // Create new giao vien
    insert: (data: sis_giaovien_view) => 
        apiClient.post(`${GIAO_VIEN_API_END_POINT}`, data),
    
    // Update existing giao vien
    update: (data: sis_giaovien_view) => 
        apiClient.put(`${GIAO_VIEN_API_END_POINT}`, data),
    
    // Delete giao vien
    delete: (id: number) => 
        apiClient.delete(`${GIAO_VIEN_API_END_POINT}/${id}`),
};
